import React from "react";
import { IoCloseSharp } from "react-icons/io5";
import { PiWarningCircleFill } from "react-icons/pi";
import { Modal, ModalBody, Table } from "reactstrap";
import GeneralButton from "../button/GeneralButton";

const JenneBackorderModal = ({ modal, toggle, backorderedItems = [], orderNumber, quoteNumber }) => {
  return (
    <Modal isOpen={modal} toggle={toggle} centered size="lg">
      <ModalBody className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center gap-2">
            <PiWarningCircleFill size={32} className="text-warning" />
            <h4 className="mb-0 fw-bold text-dark">Jenne PO Submitted with Backordered Items</h4>
          </div>
          <IoCloseSharp size={28} onClick={toggle} className="pointer text-muted" />
        </div>

        <div className="alert alert-warning py-2 mb-3">
          <p className="mb-1">
            Purchase Order was submitted successfully.
            {orderNumber && <strong> Jenne Order #: {orderNumber}</strong>}
            {quoteNumber && <span> (Quote #: {quoteNumber})</span>}
          </p>
          <small className="text-muted">
            The following item(s) are currently on backorder with Jenne:
          </small>
        </div>

        <div className="table-responsive mb-4">
          <Table bordered hover className="mb-0">
            <thead className="table-light">
              <tr className="text-uppercase" style={{ fontSize: "12px" }}>
                <th>#</th>
                <th>Part Number</th>
                <th className="text-center">Backordered Quantity</th>
                <th>Unique Identifier</th>
              </tr>
            </thead>
            <tbody>
              {backorderedItems.map((item, idx) => (
                <tr key={idx} className="align-middle">
                  <td>{idx + 1}</td>
                  <td className="fw-semibold">{item.partNo || item.PartNo || "-"}</td>
                  <td className="text-center">
                    <span className="badge bg-warning text-dark px-2 py-1">
                      {parseInt(item.quantity || item.Quantity, 10) || 0}
                    </span>
                  </td>
                  <td className="text-muted small">
                    {item.uniqueIdentifier || item.unique_identifier || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <div className="d-flex justify-content-end">
          <GeneralButton
            title="Acknowledge & Close"
            className="blue-button"
            width="180px"
            handleClick={toggle}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default JenneBackorderModal;
